const PermissionService = {
  canEditContent (role) {
    return role !== AdminRoleTypes.CompanyUser
  },

  canManageOperators (role) {
    return role !== AdminRoleTypes.CompanyUser && role !== AdminRoleTypes.HQAdministrator && role !== AdminRoleTypes.CompanyAdministrator
  },

  isHQAdministrator (role) {
    return role === AdminRoleTypes.HQAdministrator
  },

  isCompanySuperAdmin (role) {
    return role === AdminRoleTypes.CompanySuperAdmin
  },

  isCompanyAdmin (role) {
    return role === AdminRoleTypes.CompanyAdministrator
  },

  isSuperAdmin (role, username) {
    return this.IsHQAdministrator(role) && username === AdminConstants.WSLADMINUSERNAME
  },

  isDeveloperOperator (userPermission) {
    return userPermission.isDeveloperOperator
  },

  isTesterOperator (userPermission) {
    return userPermission.isTesterOperator
  },

  isSupportOperator (userPermission) {
    return userPermission.isSupportOperator
  }
}

export const AdminRoleTypes = {
  HQAdministrator: 'HQAdministrator',
  CompanySuperAdmin: 'CompanySuperAdmin',
  CompanyUser: 'CompanyUser',
  CompanyAdministrator: 'CompanyAdministrator'
}

export const AdminConstants = {
  WSLADMINUSERNAME: 'wsladmin@technogym.com',
  TechnogymStaffRoleId: 'db861299-e18d-4d29-be64-02d675c98a25'
}

export default PermissionService
